<template>
  <footer class="page-footer">
    <small>{{ $t('poweredBy') | capitalize }}
      <img
        :src="arexoLogo"
        height="15">
    </small>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      msg: 'Footer',
      arexoLogo: require('../../assets/arexo/arexo-logo-red-black.png')
    };
  }
};
</script>
